import React, { useState } from 'react';
import './LOFAScheduleSummary.scss';
import LOFAScheduleEditModeHeader from './LOFAScheduleEditModeHeader/LOFAScheduleEditModeHeader';
import {
    GetLofaSchedule,
    GetLofaSchedule_getLofaSchedule as LOFAScheduleSummaryData,
} from '../../../types/schemaTypes';
import { Query } from '../../_common';
import { Error, Loading } from '../../_common';
import { GET_LOFA_SCHEDULE } from '../../../graphql/client/queries';
import LOFAScheduleDisplayMode from './LOFAScheduleDisplayMode';

interface LOFAScheduleSummaryProps {
    jobId: number;
    isJobCompleted: boolean;
}

const LOFAScheduleSummary = ({ jobId, isJobCompleted }: LOFAScheduleSummaryProps): React.ReactElement => {
    const [isEditMode, setIsEditMode] = useState(true);
    const changeEditMode = (): void => {
        setIsEditMode(!isEditMode);
    };
    const variables = {
        jobId: jobId,
    };

    return (
        <Query<GetLofaSchedule> query={GET_LOFA_SCHEDULE} variables={variables}>
            {({ error, data, loading }): React.ReactElement | null => {
                if (loading) {
                    return <Loading />;
                }

                if (error) {
                    return <Error error={error} />;
                }

                const lofaScheduleSummaryList: LOFAScheduleSummaryData[] = [];
                const scheduleList = data?.getLofaSchedule ?? [];
                if (scheduleList.length > 0) {
                    (scheduleList as (LOFAScheduleSummaryData | null)[]).forEach((element: LOFAScheduleSummaryData | null): void => {
                        if (element != null) {
                            lofaScheduleSummaryList.push(element);
                        }
                    });
                }

                return (
                    <div className="LOFA-Container">
                        {isEditMode ? (
                            <LOFAScheduleDisplayMode
                                lofaScheduleSummaryList={lofaScheduleSummaryList}
                                changeEditMode={changeEditMode}
                                isJobCompleted={isJobCompleted}
                            />
                        ) : (
                            <LOFAScheduleEditModeHeader
                                jobId={jobId}
                                changeEditMode={changeEditMode}
                                lofaScheduleSummaryList={lofaScheduleSummaryList}
                            />
                        )}
                    </div>
                );
            }}
        </Query>
    );
};

export default LOFAScheduleSummary;

